<i18n>
{
	"en": {
		"testMode": "Put this setup in test mode. (Will not be scheduled)",
		"forwardToSight": "EDI forwarded from R10. Setup will not be scheduled",
		"setupDetails": "EDI Setup"
	},
	"no":{
		"testMode": "Sett i test modus ( Setup blir ikke schedulert )",
		"forwardToSight": "EDI blir videresendt ifra R10. Blir ikke schedulert",
		"setupDetails": "EDI oppsett"
	}
}
</i18n>

<template>
	<div class="settings-grid">
		<ModifyCommonEdiPartSetting
			:ediSetup="edisetup"
			:messageMetadata="messageMetadata.inboundMessageMetadata"
			:transportMethods="messageMetadata.inboundTransportMethod"
		/>

		<div class="controll-settings-grid">
			<t-switch v-model="edisetup.testMode" :label="$t('testMode')"/>
			<t-switch v-model="edisetup.forwardEdiToTmsSight" disabled :label="$t('forwardToSight')"/>
		</div>

	</div>
</template>

<script>

import ModifyCommonEdiPartSetting from '../../ModifyCommonEdiPartSetting.vue';
export default {
	name: 'SetupDetails',
	components: { ModifyCommonEdiPartSetting },
	props: {
		messageMetadata: Object,
		edisetup: Object
	}
};
</script>

<style lang="scss" scoped>

.settings-grid{
	display: grid;
	row-gap: 5px;
}

.controll-settings-grid{
	padding-top: 5px;
	max-width:300px;
	display:grid;
	row-gap: 5px;
	grid-column: 50px;
}
</style>